import React from 'react';

// Custom Hook Function to prevent window unload
export function usePreventWindowUnload(preventWindowUnload) {
  // Prevent window unload
  // https://angelos.dev/2019/05/custom-react-hook-to-prevent-window-unload/
  React.useEffect(() => {
    if (!preventWindowUnload) return;
    const handleBeforeUnload = (e) => {
      e.preventDefault();

      // Chrome requires returnValue to be set.
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [preventWindowUnload]);
}
